"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppShell = void 0;
const React = require("react");
const DimensionsMonitor_1 = require("./DimensionsMonitor");
const Header_1 = require("./Header");
const HeaderDesktop_1 = require("./HeaderDesktop");
const MenuMobile_1 = require("./MenuMobile");
const MenuDesktop_1 = require("./MenuDesktop");
const theme_1 = require("../modules/theme");
const react_native_1 = require("react-native");
class AppShell extends React.Component {
    constructor() {
        super(...arguments);
        this.menu = null;
        this.getMobileStyles = () => {
            const theme = (0, theme_1.getTheme)();
            const styles = react_native_1.StyleSheet.create({
                container: {
                    flex: 1,
                    padding: 16,
                    height: react_native_1.Dimensions.get('window').height - HeaderDesktop_1.HeaderDesktop.height,
                    // @ts-ignore: O react-native não tem auto, mas o react-native-web aceita
                    overflow: 'auto'
                },
                logoText: {
                    color: theme.textColor1,
                    fontFamily: theme.fontFamily3,
                    fontSize: 22,
                    marginLeft: 10,
                    display: 'flex',
                    alignItems: 'center'
                }
            });
            return styles;
        };
        this.getDesktopStyles = () => {
            const styles = react_native_1.StyleSheet.create({
                container: {
                    flexDirection: 'row',
                    flex: 1
                },
                content: {
                    flex: 1,
                    padding: 16,
                    height: react_native_1.Dimensions.get('window').height - HeaderDesktop_1.HeaderDesktop.height,
                    // @ts-ignore: O react-native não tem auto, mas o react-native-web aceita
                    overflow: 'auto'
                }
            });
            return styles;
        };
        this.renderMobile = () => {
            const { title, logoMenu, screenTitle, renderUserData, menu, onMenuPress, isCurrentMenuPath, children, rightButton } = this.props;
            const styles = this.getMobileStyles();
            return (React.createElement(MenuMobile_1.MenuMobile, { ref: ref => (this.menu = ref), menu: menu, onMenuPress: onMenuPress, isCurrentMenuPath: isCurrentMenuPath, renderLogo: () => (React.createElement(React.Fragment, null,
                    logoMenu(),
                    title && React.createElement(react_native_1.Text, { style: styles.logoText }, title))), renderUserData: renderUserData },
                React.createElement(Header_1.Header, { title: screenTitle, leftButton: {
                        nativeID: 'menu-hamburguer',
                        icon: 'bars',
                        onPress: () => this.menu.open()
                    }, rightButton: rightButton }),
                React.createElement(react_native_1.View, { style: styles.container }, children)));
        };
        this.renderDesktop = () => {
            const { title, logoHeader, greeting, menu, onMenuPress, isCurrentMenuPath, children, rightButton, renderUserData, headerStyle } = this.props;
            const styles = this.getDesktopStyles();
            return (React.createElement(React.Fragment, null,
                React.createElement(HeaderDesktop_1.HeaderDesktop, { title: title, logo: logoHeader, greeting: greeting, rightButton: rightButton, headerStyle: headerStyle }),
                React.createElement(react_native_1.View, { style: styles.container },
                    React.createElement(MenuDesktop_1.MenuDesktop, { menu: menu, headerHeight: HeaderDesktop_1.HeaderDesktop.height, onMenuPress: onMenuPress, isCurrentMenuPath: isCurrentMenuPath, renderUserData: renderUserData }),
                    React.createElement(react_native_1.View, { nativeID: "app-shell-desktop-content", style: styles.content }, children))));
        };
    }
    render() {
        return (React.createElement(DimensionsMonitor_1.DimensionsMonitor, null, ({ isDesktop }) => isDesktop || this.props.alwaysDesktop
            ? this.renderDesktop()
            : this.renderMobile()));
    }
}
exports.AppShell = AppShell;
